import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { changeCauseIncident } from './change-cause-incident';

const fieldId = 'failure_incident_reference';

const initialValues = '';

const vFParams = {
  fieldTitle: 'If yes, please enter incident reference:',
  placeholder: 'Enter INC reference',
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();
  // When changeCauseIncident field is "Yes" will do validate
  const shouldValidate = values[changeCauseIncident.id].includes('Yes');
  if (shouldValidate) {
    /* ERROR CHECKERS */
    const noValue = commonValidation.noValue(values[fieldId], VF_INPUT);

    /* ADD ERRORS TO ERROR OBJECT */
    // errors[INLINE_ERRORS].push((noValue && !optional) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);
    errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please ensure you have answered all the questions in the Post Change Review.' : null);
  }

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const enterIncidentReference = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_INPUT,
};

export { enterIncidentReference };
